(function($) {
  $('.collapsible').each((i, el) => {
    $(el).on('hover', event => {
      var el = event.currentTarget;
      var text = event.currentTarget.querySelector('.text');
      var w = text.scrollWidth + 1;
      
      if ('mouseenter' === event.type) {
        el.classList.add('show');
        text.style.maxWidth = w + 'px';
      }
      
      if ('mouseleave' === event.type) {
        el.classList.remove('show');
        text.style.maxWidth = '';
      }
    });
  });

  $('.site-header').on('mini', () => {
    $('.topbar .dropdown-toggle').dropdown('hide');
  })
})(jQuery);